module.exports = __webpack_public_path__ + "img/eth.548408c6.svg";